module.exports = __webpack_public_path__ + "img/Hawk and man.ca414898.svg";